export default __webpack_public_path__ + "static/media/slider.6b911ac4.png";